import React, { useEffect, useState } from 'react';
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import CoreFeature from './CoreFeature';

function MobileAccess() {
   useEffect(() => {
      window.scrollTo(0, 0);
   }, []);



   return (


      <>
         <Helmet>
            <title>Enhance Your Business Security with Mobile Access Management.</title>
         </Helmet>
            <div class="block-style-thirtySix bg-white lg-container pt-110 pb-80 " id="feature">
               <div class="container">
                  <div class="row">
                     <div class="col-xl-6 col-lg-7  aos-init aos-animate" data-aos="fade-left">
                        <div class="pl-lg-5">
                           <div class="title-style-fourteen">
                              <h6><span class="upper-title custom-name">Mobile Access</span></h6>
                              <h1>Manage projects from anywhere.</h1>
                           </div>
                           <div class="tag-line">In today's rapidly changing business environment being able to manage projects from anywhere is essential. No matter where you are, TaskFlier brings the power of project management directly to your mobile device enabling you to monitor and control projects at your fingertips.</div>

                        </div>
                     </div>
                     <div class="col-xl-6 col-lg-5 text-center text-lg-left  aos-init aos-animate" data-aos="fade-right">
                        <div class="illustration-holder d-inline-block md-mt-60">
                           <img src="/main/images/mobile-app.png" alt="" class="w-100" />

                        </div>
                     </div>
                  </div>
               </div>
            </div>

            <div class="fancy-feature-thirtyFour pt-80 pb-100 bg-gray">
               <div class="container">
                  <div class="title-style-two text-center mb-40 md-mb-40">
                     <h6><span class="upper-title custom-name">Explore Taskflier Features!</span></h6>


                     <div class="sub-text mt-0 pt-3 maxsubtitle">Frequent difficulties encountered in the software sector.
                        Obstacles are a part of every project. But which ones affect software development?
                     </div>
                  </div>

                  <div class="row  features">


                     <div class="col-lg-4 col-12 ">

                        <div class="Solutions-box " >
                           <img src="/main/images/mobileapp-view.png" alt="Task creation" class="w-100" />
                           <div class="pack-name mt-3 text-capitalize">Instant access</div>
                           <hr></hr>
                           <p className="mainp">With TaskFlier's Mobile App, team members have instant access to all project information. Whether you are on-site with a client, traveling, or away from your desk, you can manage and work on projects as if you were in the office sitting on your desktop system. TaskFlier Mobile App enables you to carry your office on a mobile device/phone wherever you go. </p>


                        </div>

                     </div>
                     <div class="col-lg-4 col-12 ">

                        <div class="Solutions-box " >
                           <img src="/main/images/smooth-performance.png" alt="Smooth performance" class="w-100" />
                           <div class="pack-name mt-3 text-capitalize">Smooth performance management
                           </div>
                           <hr></hr>
                           <p className="mainp">The Mobile Interface feature in TaskFlier allows managers to manage tasks, track progress, and communicate with teams anytime, anywhere with a simple click or swipe. Optimized for smartphones and tablets, it ensures seamless access to project data on the go, boosting productivity, responsiveness, and collaboration beyond the confines of a desktop environment.</p>

                        </div>

                     </div>
                     <div class="col-lg-4 col-12 ">

                        <div class="Solutions-box " >
                           <img src="/main/images/platform-independence.png" alt="Platform independence" class="w-100" />
                           <div class="pack-name mt-3 text-capitalize">Platform independence</div>
                           <hr></hr>
                           <p className="mainp">TaskFlier’s Mobile App is available on both Android and iOS platforms, ensuring seamless access across devices. Users can manage tasks, track updates, and collaborate in real-time from anywhere. This cross-platform support enhances flexibility, productivity, and on-the-go project control for all team members.</p>


                        </div>
                     </div>



                  </div>
               </div>
            </div>


            <CoreFeature />
            <div className="faq-classic pt-0 bg-white">
               <div className="container">
                  <div className="row">
                     <div className="col-lg-12">
                        <div className="title-style-one mb-40">
                           <h6 className="font-rubik">Find your answers</h6>
                           <h2>Have any thought? Look here.</h2>
                        </div>
                     </div>
                     <div className="col-lg-12">
                        <div id="accordion" className="md-mt-60">
                           <div className="card">
                              <div className="card-header" id="headingOne">
                                 <h5 className="mb-0">
                                    <button
                                       className="btn btn-link"
                                       data-bs-toggle="collapse"
                                       data-bs-target="#collapseOne"
                                       aria-expanded="true"
                                       aria-controls="collapseOne"
                                    >
                                       How does the Mobile Access feature help?
                                    </button>
                                 </h5>
                              </div>
                              <div
                                 id="collapseOne"
                                 className="accordion-collapse collapse show"
                                 data-bs-parent="#accordion"
                              >
                                 <div className="card-body">
                                    <p>
                                       The Mobile Access feature allows users and management to access TaskFlier via smartphones or tablets. It delivers core functionalities directly to mobile devices, enabling work from anywhere, anytime.
                                    </p>
                                 </div>
                              </div>
                           </div>
                           <div className="card">
                              <div className="card-header" id="headingTwo">
                                 <h5 className="mb-0">
                                    <button
                                       className="btn btn-link"
                                       data-bs-toggle="collapse"
                                       data-bs-target="#collapseTwo"
                                       aria-expanded="true"
                                       aria-controls="collapseTwo"
                                    >
                                       Which mobile platforms are supported?
                                    </button>
                                 </h5>
                              </div>
                              <div
                                 id="collapseTwo"
                                 className="accordion-collapse collapse "
                                 data-bs-parent="#accordion"
                              >
                                 <div className="card-body">
                                    <p>
                                       TaskFlier is available on both iOS and Android platforms. Users can download it from the App Store or Google Play and log in with their existing company portal using their individual credentials.
                                    </p>
                                 </div>
                              </div>
                           </div>
                           <div className="card">
                              <div className="card-header" id="headingThree">
                                 <h5 className="mb-0">
                                    <button
                                       className="btn btn-link"
                                       data-bs-toggle="collapse"
                                       data-bs-target="#collapseThree"
                                       aria-expanded="true"
                                       aria-controls="collapseThree"
                                    >
                                       Can I manage tasks and projects from my mobile device?
                                    </button>
                                 </h5>
                              </div>
                              <div
                                 id="collapseThree"
                                 className="accordion-collapse collapse"
                                 data-bs-parent="#accordion"
                              >
                                 <div className="card-body">
                                    <p>
                                       Yes. The mobile app supports full task management, including creating, editing, assigning, and tracking tasks. Managers can also view project dashboards and approve or modify timelines on the go.
                                    </p>
                                    <p>Simply download the app from your device’s app store, install it, and log in using your company credentials. A quick-start guide is available within the app to help you begin right away.

                                    </p>


                                 </div>
                              </div>
                           </div>

                           <div className="card">
                              <div className="card-header" id="headingFour">
                                 <h5 className="mb-0">
                                    <button
                                       className="btn btn-link"
                                       data-bs-toggle="collapse"
                                       data-bs-target="#collapseFour"
                                       aria-expanded="true"
                                       aria-controls="collapseFour"
                                    >
                                       Is the mobile experience the same as the desktop version?
                                    </button>
                                 </h5>
                              </div>
                              <div
                                 id="collapseFour"
                                 className="accordion-collapse collapse "
                                 data-bs-parent="#accordion"
                              >
                                 <div className="card-body">
                                    <p>
                                       While the mobile version is optimized for smaller screens, it retains all essential features such as real-time updates, notifications, document sharing, and communication tools to maintain productivity on the move.
                                    </p>
                                 </div>
                              </div>
                           </div>
                           <div className="card">
                              <div className="card-header" id="headingThree">
                                 <h5 className="mb-0">
                                    <button
                                       className="btn btn-link"
                                       data-bs-toggle="collapse"
                                       data-bs-target="#collapseThree"
                                       aria-expanded="true"
                                       aria-controls="collapseThree"
                                    >
                                       Can I receive real-time notifications on mobile?
                                    </button>
                                 </h5>
                              </div>
                              <div
                                 id="collapseThree"
                                 className="accordion-collapse collapse"
                                 data-bs-parent="#accordion"
                              >
                                 <div className="card-body">
                                    <p>
                                       Absolutely. You’ll receive push notifications for task updates, messages, deadlines, and approvals, ensuring you stay informed and responsive wherever you are.
                                    </p>


                                 </div>
                              </div>
                           </div>

                           <div className="card">
                              <div className="card-header" id="headingThree">
                                 <h5 className="mb-0">
                                    <button
                                       className="btn btn-link"
                                       data-bs-toggle="collapse"
                                       data-bs-target="#collapseThree"
                                       aria-expanded="true"
                                       aria-controls="collapseThree"
                                    >
                                       Is mobile access secure?
                                    </button>
                                 </h5>
                              </div>
                              <div
                                 id="collapseThree"
                                 className="accordion-collapse collapse"
                                 data-bs-parent="#accordion"
                              >
                                 <div className="card-body">
                                    <p>
                                       Yes. The mobile app is protected with multi-layered security including data encryption, biometric login (fingerprint/face recognition), and secure session management to ensure your company data remains protected.</p>


                                 </div>
                              </div>
                           </div>

                           <div className="card">
                              <div className="card-header" id="headingThree">
                                 <h5 className="mb-0">
                                    <button
                                       className="btn btn-link"
                                       data-bs-toggle="collapse"
                                       data-bs-target="#collapseThree"
                                       aria-expanded="true"
                                       aria-controls="collapseThree"
                                    >
                                       Can multiple team members use the app simultaneously?
                                    </button>
                                 </h5>
                              </div>
                              <div
                                 id="collapseThree"
                                 className="accordion-collapse collapse"
                                 data-bs-parent="#accordion"
                              >
                                 <div className="card-body">
                                    <p> Yes. All authorized users can access the mobile app concurrently. Data syncs in real time, so team members stay aligned no matter where they are working from.</p>


                                 </div>
                              </div>
                           </div>

                        </div>
                     </div>
                  </div>
               </div>
            </div>

      </>

   )
}

export default MobileAccess
